import store from "@/store/store"
import clsx from "clsx"
import { observer } from "mobx-react-lite"
import Link from "next/link"

type FooterProps = {
    variant?: "onDark" | "onLight"
}

const Footer = observer(function Footer({ variant }: FooterProps) {
    const tr = store.globalData?.translations?.[0];
    const imprintLink = tr?.imprint_link ?? "#";
    const imprintLabel = tr?.imprint_label ?? "Impressum";
    const privacyLink = tr?.data_privacy_link ?? "#";
    const privacyLabel = tr?.data_privacy_label ?? "Datenschutz";

    return (
        <div className={clsx("flex justify-center items-center gap-4 w-svw h-10.25 min-h-10.25 font-12-semiBold text-green-800 underline", variant === "onDark" && "text-white")}>
            <Link href={imprintLink} target="_blank" rel="noopener noreferrer">{imprintLabel}</Link>
            <button className="cursor-pointer" onClick={() => store.open("legalDataPrivacy")}>{privacyLabel}</button>
        </div>
    )
})

export default Footer
